import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CalculatorModel, IViewStates } from '../_models/calculator.model';

@Injectable()
export class GlobalService {
  isError: boolean;
  isLoadingApp: boolean;
  isLoadingContent: boolean;

  // observable stream source
  genericEventSource = new Subject<any>();
  genericEvent$ = this.genericEventSource.asObservable();

  calculator: any;

  // primary calculator model
  calculatorModel: CalculatorModel;

  constructor() {
    console.debug('GlobalService().constructor()');
    // set up event trigger for window.resize

    this.isError = false;
    this.isLoadingApp = false;
    this.isLoadingContent = false;

    let timerWindowResize;
    let self = this;
    window.onresize = () => {

      // clear timer if already set
      clearTimeout(timerWindowResize);

      // set timer
      timerWindowResize = setTimeout(
        function () {
          self.triggerGenericEvent('window.resize()');
        },
        250);
    };
  }

  triggerGenericEvent(event: any) {
    this.genericEventSource.next(event);
  }
}
